import FileName from "./FileName";

export default function PreviewAudioFile({file, highlight}) {
	return (
		<>
			<div className={"small text-break"}><FileName name={file.fileName} highlight={highlight} /></div>
			<audio className={"mw-100"} style={{maxWidth: "100%"}} controls src={process.env.REACT_APP_ENDPOINT  + '/files/' + file.key + '?redirect=1'} />
		</>
	)
}
